export default __webpack_public_path__ + "static/media/113_mobile.7ec85ea1.jpg";